import { gql } from "graphql-request";

const wordPressGetGravityFormById = (id: string | number) => {
	return {
		operationName: "GetGravityFormById",
		variables: {
			id,
		},
		query: gql`
			query GetGravityFormById($id: ID!) {
				gfForm(id: $id, idType: DATABASE_ID) {
					databaseId
					title
					description
					submitButton {
						text
					}
					confirmations {
						isDefault
						message
					}
					formFields {
						nodes {
							id
							type
							layoutGridColumnSpan
							visibility
							... on NumberField {
								...NumberFieldFields
							}
							... on NameField {
								...NameFieldFields
							}
							... on AddressField {
								...AddressFieldFields
							}
							... on EmailField {
								...EmailFieldFields
							}
							... on PhoneField {
								...PhoneFieldFields
							}
							... on TextAreaField {
								...TextAreaFieldFields
							}
							... on TextField {
								...TextFieldFields
							}
							... on ConsentField {
								...ConsentFieldFields
							}
							... on FileUploadField {
								...FileUploadFieldFields
							}
							... on SelectField {
								...SelectFieldFields
							}
							... on CheckboxField {
								...CheckboxFieldFields
							}
							... on RadioField {
								...RadioFieldFields
							}
							... on SurveyField {
								...SurveyFieldFields
							}
						}
					}
				}
			}			
			fragment NumberFieldFields on NumberField {
				id
				isRequired
				label
				placeholder
			}			
			fragment NameFieldFields on NameField {
				id
				label
				isRequired
				inputs {
					id
					... on NameInputProperty {
						isHidden
						key
						label
						customLabel
						placeholder
					}
				}
			}
			fragment EmailFieldFields on EmailField {
				id
				isRequired
				label
				placeholder
			}
			fragment AddressFieldFields on AddressField {
				id
				label
				isRequired
				inputs {
					... on AddressInputProperty {
						isHidden
						key
						label
						customLabel
						placeholder
					}
				}
			}
			fragment PhoneFieldFields on PhoneField {
				id
				isRequired
				label
				placeholder
				isRequired
			}
			fragment TextAreaFieldFields on TextAreaField {
				id
				isRequired
				label
				placeholder
				size
			}
			fragment TextFieldFields on TextField {
				id
				isRequired
				label
				placeholder
			}		
			fragment RadioFieldFields on RadioField {
				id
				isRequired
				label 
				choices {
					... on RadioFieldChoice {
						text
						value
					}
				}				
			}
			fragment ConsentFieldFields on ConsentField {
				id
				isRequired
				label
				checkboxLabel
			}
			fragment FileUploadFieldFields on FileUploadField {
				id
				errorMessage
				fileUploadValues {
					filename
					url
				}
				allowedExtensions
				isRequired
				label
				maxFileSize
				maxFiles
			}
			fragment SelectFieldFields on SelectField {
				id
				label
				isRequired
				cssClass
				choices {
					... on SelectFieldChoice {
					isSelected
					text
					value
					}
				}
			}
			fragment CheckboxFieldFields on CheckboxField {
				id
				label
				isRequired
				inputs {
					... on CheckboxInputProperty {
						id
						name
						label
					}
				}
			}
			fragment SurveyFieldFields on SurveyField {
				id
				value
				cssClass
				adminLabel
				inputType
			}  
		`,
	};
};

export default wordPressGetGravityFormById;
